import React from 'react';
import AuthenticationForm from './AuthenticationForm';
import UpgradeToContact from './UpgradeToContact';
import HiddenInputs from './HiddenInputs';
import AdvertiserDetails from './AdvertiserDetails';
import PhoneInfo from './PhoneInfo';
import Notification from './Notification';

function paymentCallback() {
  window.location.reload();
}

const PhoneForm = (props) => (
  <div className="contact-form">
    <AdvertiserDetails
      profilePhotoUrl={
        props.pageData.advert.user.profile_photo_url ||
        `${props.staticData.site.static_files_server}/img/spareroom/v4/icons/profilepic_unisex.gif`
      }
      advert={props.pageData.advert}
      staticFilesServer={props.staticData.site.static_files_server}
      action={'Call'}
      localisations={props.pageLocalisations}
    />
    <Notification
      user={props.pageData.user}
      upgradeRequired={
        props.staticData.customer.id && props.pageData.upgrade_required
      }
      contactType={'phone'}
      localisations={props.pageLocalisations}
      siteName={props.staticData.page.site_name}
    />
    <form
      className="form"
      id="contact_form"
      action={props.pageData.contact_form_action}
      method="POST"
    >
      <HiddenInputs {...props.pageData} />
      {!props.staticData.customer.id ? (
        <>
          <p>{props.pageLocalisations.logged_in_to_view_content}</p>
          <AuthenticationForm
            advertType={props.pageData.advert.type}
            user={props.pageData.user}
            error={props.pageData.error}
            country={props.staticData.site.country}
            userKnown={props.staticData.session.user_known}
            csrf_token={props.pageData.csrf_token}
            subDir={props.staticData.site.sub_dir}
            contactMode={props.pageData.contact_mode}
            facebookAppLocale={props.facebookAppLocale}
            loginFromUrl={props.staticData.site.loginReturnPath}
            locationId={props.pageData.search.location_id}
            affiliateId={props.staticData.affiliate.id}
            localisations={props.pageLocalisations}
            siteId={props.siteId}
          />
        </>
      ) : null}
    </form>
    {props.staticData.customer.id && !props.pageData.upgrade_required ? (
      <PhoneInfo
        advertiser={props.pageData.advert.user}
        advert={props.pageData.advert}
        search={props.pageData.search}
        alertId={props.pageData.alertId}
        alertType={props.pageData.alertType}
        siteName={props.pageData.site_name}
        upgradeRequired={props.pageData.upgradeRequired}
        scriptPath={props.staticData.site.script_path}
        subDir={props.staticData.site.sub_dir}
        contacted={props.pageData.sl_context}
        staticFilesServer={props.staticData.site.static_files_server}
        localisations={props.pageLocalisations}
      />
    ) : null}
    {props.staticData.customer.id && props.pageData.upgrade_required ? (
      <UpgradeToContact {...props} paymentCallback={paymentCallback} />
    ) : null}
  </div>
);

export default PhoneForm;
